import { Link } from "react-router-dom";
import { useLocale } from "../i18n/LocaleContext";
import { TREATMENT_IMAGES_EXTRA } from "../data/treatments";
import { Reveal, Eyebrow } from "../components/Reveal";

export default function About() {
  const { t, link } = useLocale();
  return (
    <div data-testid="about-page">
      <section className="mx-auto max-w-[1600px] px-6 pt-40 sm:px-10 lg:px-16 lg:pt-52">
        <Reveal>
          <Eyebrow>{t("about.eyebrow")}</Eyebrow>
          <h1 className="mt-6 font-serif text-5xl font-light text-imperium-black sm:text-7xl">{t("about.title")}</h1>
          <p className="mt-5 text-[11px] font-label uppercase tracking-[0.35em] text-imperium-bronze">{t("about.role")}</p>
        </Reveal>
      </section>

      <section className="mx-auto grid max-w-[1600px] gap-16 px-6 py-20 sm:px-10 lg:grid-cols-12 lg:px-16 lg:py-28">
        <div className="lg:col-span-6">
          <Reveal>
            <div className="relative max-w-md">
              <img src="/assets/img/lei-sobre.jpg" alt="Leidiane Alcântara" data-testid="about-portrait" className="h-auto w-full" />
              <div className="pointer-events-none absolute -bottom-5 -right-5 -top-5 left-5 border border-imperium-gold/50" aria-hidden="true" />
            </div>
          </Reveal>
        </div>
        <div className="lg:col-span-5 lg:col-start-8">
          <Reveal>
            <div className="space-y-6">
              {t("about.bio").map((p, i) => (
                <p key={i} className="text-base font-light leading-relaxed text-imperium-black/75" data-testid={`about-bio-${i}`}>{p}</p>
              ))}
            </div>
          </Reveal>
        </div>
      </section>

      <section className="bg-imperium-offwhite">
        <div className="mx-auto max-w-3xl px-6 py-24 text-center lg:py-32">
          <Reveal>
            <p className="font-serif text-3xl font-light italic leading-snug text-imperium-bronze sm:text-4xl" data-testid="about-quote">{t("about.quote")}</p>
            <p className="mt-8 text-[11px] font-label uppercase tracking-[0.35em] text-imperium-brown/70">Leidiane Alcântara</p>
          </Reveal>
        </div>
      </section>

      <section className="mx-auto max-w-[1600px] px-6 py-24 sm:px-10 lg:px-16 lg:py-36">
        <div className="grid gap-14 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Reveal>
              <Eyebrow>{t("about.storyEyebrow")}</Eyebrow>
              <h2 className="mt-6 font-serif text-4xl font-light leading-tight text-imperium-black sm:text-5xl">{t("about.storyTitle")}</h2>
              <div className="mt-10 overflow-hidden">
                <img src={TREATMENT_IMAGES_EXTRA.consult2} alt="Leidiane Alcântara im persönlichen Gespräch" loading="lazy" data-testid="about-story-image" className="aspect-[4/5] w-full object-cover transition-transform duration-700 hover:scale-[1.03] lg:aspect-[3/4]" />
              </div>
            </Reveal>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal delay={0.12}>
              <div className="space-y-6">
                {t("about.story").map((p, i) => (
                  <p key={i} className="text-base font-light leading-relaxed text-imperium-black/75" data-testid={`about-story-${i}`}>{p}</p>
                ))}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="border-y border-imperium-champagne/40">
        <div className="mx-auto grid max-w-[1600px] gap-10 px-6 py-20 sm:px-10 lg:grid-cols-12 lg:px-16 lg:py-28">
          <div className="lg:col-span-4">
            <Reveal>
              <Eyebrow>{t("about.philosophyEyebrow")}</Eyebrow>
              <h2 className="mt-6 font-serif text-3xl font-light text-imperium-black sm:text-4xl">{t("about.philosophyTitle")}</h2>
            </Reveal>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal delay={0.1}>
              <p className="text-lg font-light leading-relaxed text-imperium-black/70">{t("about.philosophyText")}</p>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-6 py-24 text-center lg:py-32">
        <Reveal>
          <h2 className="font-serif text-4xl font-light text-imperium-black sm:text-5xl">{t("about.ctaTitle")}</h2>
          <p className="mx-auto mt-6 max-w-md text-base font-light leading-relaxed text-imperium-black/70">{t("about.ctaText")}</p>
          <Link
            to={link("contact")}
            data-testid="about-cta"
            className="mt-10 inline-block border border-imperium-bronze px-8 py-4 text-[11px] font-label uppercase tracking-[0.25em] text-imperium-brown transition-colors duration-300 hover:bg-imperium-brown hover:text-imperium-white"
          >
            {t("cta.book")}
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
